export enum ImageType{
    LOGO = "logo"
}